export default __webpack_public_path__ + "static/media/YvetteLovelace.3bebaef4.png";